"use client";

import { createContext, useContext, useState, useEffect } from "react";
import { retrieveMasterCity } from "../services/locationServices";

const LocationContext = createContext(undefined);

export function LocationProvider({ children }) {
  const [locationData, setLocationData] = useState({
    latitude: null,
    longitude: null,
    error: null,
    loading: true,
  });

  // useEffect(() => {
  //   async function handleLocationChange() {
  //     const storedPhoneNumber = localStorage.getItem("phoneNumber");
  //     if (storedPhoneNumber && testAccounts.includes(storedPhoneNumber)) {
  //       const testGeohash = testAccountGeohashes[storedPhoneNumber];
  //       if (testGeohash) {
  //         localStorage.setItem("geohash", testGeohash);
  //         console.log(
  //           `Test account detected: ${storedPhoneNumber}, setting geohash: ${testGeohash}`
  //         );
  //         return;
  //       }
  //     }
  //     const payload = {
  //       latitude: locationData.latitude,
  //       longitude: locationData.longitude,
  //       state: "",
  //       city: "",
  //     };
  //     try {
  //       const cityResponse = await retrieveMasterCity(payload);
  //       if (cityResponse.geohash && cityResponse.geohash.geohash) {
  //         localStorage.setItem("geohash", cityResponse.geohash.geohash);
  //       }
  //     } catch (error) {
  //       console.error("Error while changing location", error);
  //     }
  //   }

  //   if (!locationData.latitude || !locationData.longitude) {
  //     return;
  //   }
  //   handleLocationChange();
  // }, [locationData]);

  useEffect(() => {
    // Test accounts configuration
    const testAccounts = [
      // City-specific accounts
      "+1000000001", // New York
      "+1000000002", // Los Angeles
      "+1000000003", // Chicago
      "+1000000004", // Miami
      "+1000000005", // Seattle
      // Universal accounts
      "+1000000006",
      "+1000000007",
      "+1000000008",
      "+1000000009",
      "+1000000010",
    ];

    // Geohash mapping for test accounts
    const testAccountGeohashes = {
      "+1000000001": "dr5r", // New York
      "+1000000002": "9q5c", // Los Angeles
      "+1000000003": "dp3w", // Chicago
      "+1000000004": "dhjv", // Miami
      "+1000000005": "c23n", // Seattle
      "+1000000006": "",
      "+1000000007": "",
      "+1000000008": "",
      "+1000000009": "",
      "+1000000010": "",
    };

    async function handleLocationChange() {
      const storedPhoneNumber =
        localStorage.getItem("phoneNumber") ||
        JSON.parse(localStorage.getItem("profile") || "{}").mobileno;
      if (storedPhoneNumber && testAccounts.includes(storedPhoneNumber)) {
        const testGeohash = testAccountGeohashes[storedPhoneNumber];
        localStorage.setItem("geohash", testGeohash);
        return;
      }

      const payload = {
        latitude: locationData.latitude,
        longitude: locationData.longitude,
        state: "",
        city: "",
      };

      try {
        const cityResponse = await retrieveMasterCity(payload);
        if (cityResponse.geohash && cityResponse.geohash.geohash) {
          localStorage.setItem("geohash", cityResponse.geohash.geohash);
        }
      } catch (error) {
        console.error("Error while changing location", error);
      }
    }

    if (!locationData.latitude || !locationData.longitude) {
      return;
    }

    handleLocationChange();
    const onStorageChange = () => handleLocationChange();
    window.addEventListener("storage", onStorageChange);

    return () => window.removeEventListener("storage", onStorageChange);
  }, [locationData]);

  const requestLocation = () => {
    if (typeof window === "undefined" || !navigator.geolocation) {
      setLocationData((prev) => ({
        ...prev,
        error: "Geolocation is not supported by your browser",
        loading: false,
      }));
      return;
    }

    setLocationData((prev) => ({ ...prev, loading: true }));

    navigator.geolocation.getCurrentPosition(
      (position) => {
        setLocationData({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
          error: null,
          loading: false,
        });
      },
      (error) => {
        setLocationData({
          latitude: null,
          longitude: null,
          error: error.message,
          loading: false,
        });
      }
    );
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      requestLocation();
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  return (
    <LocationContext.Provider value={{ locationData, requestLocation }}>
      {children}
    </LocationContext.Provider>
  );
}

export function useLocation() {
  const context = useContext(LocationContext);
  if (context === undefined) {
    throw new Error("useLocation must be used within a LocationProvider");
  }
  return context;
}
